// src/Services/incomes.jsx
import api from "./api";
import { useUserSuperEmpresa } from "../Context/AuthContext";
import { useEffect, useState } from "react";

export const useIncomesService = () => {
  const { Token } = useUserSuperEmpresa();

  const getIncomes = async (params = {}) => {
    try {
      const { data } = await api.get("/incomes", { 
        params,
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        }
      });
      return data.data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener ingresos";
    }
  };

  const getIncomescard = async () => {
  try {
    const { data } = await api.get("/income/resumen-ultimo-mes", {
      headers: {
        Authorization: `Bearer ${Token}`,
      }
    });
    return data.data;
  } catch (error) {
    throw error.response?.data?.message || "Error al obtener ingresos";
  }
};


const getContact = async () => {
  try {
    const { data } = await api.get(`/contacts`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    });

    return data;

  } catch (error) {
    throw error.response?.data?.message || "Error al obtener contactos";
  }
};
  

   const getIncomesSearch = async (params = {}) => {
    try {
      const { data } = await api.get("/incomes/search", { 
        params,
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        }
      });
      return data.data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener ingresos";
    }
  };


  const postIncomes = async (params = {}) => {
    try {
      const { data } = await api.post("/incomes/store", params, {
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        },
      });
      return data.data;
    } catch (error) {
      throw error.response?.data?.message || "Error al crear ingreso";
    }
  };

   const putIncomes = async (id, params = {}) => {
    try {
      const { data } = await api.post(`/incomes/update/${id}`, params, {
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        },
      });
      return data.data;
    } catch (error) {
      throw error.response?.data?.message || "Error al crear ingreso";
    }  
  };


 const DeleteIncomes = async (id) => {
  try {
    const { data } = await api.delete(`/incomes/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    });
    return data;
  } catch (error) {
    throw error.response?.data?.message || "Error al eliminar ingreso";
  }
};

  return { getIncomesSearch, getIncomes, postIncomes, DeleteIncomes, putIncomes, getIncomescard, getContact};
};


/* funciones de llamados */

export const useSearchIncome = (month, year) => {
  const { Token } = useUserSuperEmpresa();
  const { getIncomesSearch } = useIncomesService();
  const [buscaringreso, setBuscarIngreso] = useState([]);
  const [loadings, setLoadings] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchIncomeSearch = async () => {
      setLoadings(true);
      try {
        const data = await getIncomesSearch({ month, year }); // pasamos mes y año al service
        setBuscarIngreso(data);
        setError(null);
      } catch (err) {
        setError(err);
        setBuscarIngreso([]);
      } finally {
        setLoadings(false);
      }
    };

    if (month && year) {
      fetchIncomeSearch();
    }
  }, [Token, month, year]);

  return { buscaringreso, loadings, error };
};


export const useGetIngresoCard = () => {
  const { getIncomescard } = useIncomesService(); // 👉 ahora sí lo obtenemos del service
  const [ingreso, setIngresos] = useState([]);
  const [loadingIngreso, setLoadingIngreso] = useState(false);
  const [errorIngreso, setErrorIngreso] = useState(null);

  const fetchIngreso = async () => {
    setLoadingIngreso(true);
    try {
      const data = await getIncomescard(); 
      setIngresos(data);
      setErrorIngreso(null);
    } catch (error) {
      console.error("💥 Error al obtener ingresos:", error);
      setErrorIngreso(error);
    } finally {
      setLoadingIngreso(false);
    }
  };

  useEffect(() => {
    fetchIngreso();
  }, []);

  return {
    ingreso,
    loadingIngreso,
    errorIngreso,
    refetchIngresos: fetchIngreso,
  };
};



export const useGetContact = () => {
  const { getContact } = useIncomesService();
  const [contacts, setContacts] = useState([]);
  const [loadingContact, setLoadingContact] = useState(false);
  const [errorContact, setErrorContact] = useState(null);

  const searchContacts = async (query = null) => {
    setLoadingContact(true);
    try {
      const data = await getContact(query);
      setContacts(data);
      setErrorContact(null);
    } catch (error) {
      console.error("💥 Error al obtener Contacts:", error);
      setErrorContact(error);
    } finally {
      setLoadingContact(false);
    }
  };

  return {
    contacts,
    loadingContact,
    errorContact,
    searchContacts, // 👈 sin search obligatorio
  };
};
